export default __webpack_public_path__ + "media/images/portfolio/width-600/portfolio-9-9d6666cb0116e6d43bae9520b8e4957a.jpg";